import type { Kudo as KudoModel } from 'models';
import { Avatar, Flex, MedalLineIcon, Text, Title } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useGetUserNameWithFallback } from 'features/users/hooks';

type P = {
  kudo: KudoModel;
};

const Kudo = ({ kudo }: P) => {
  const { user } = kudo;
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const fullName = getUserNameWithFallback(user);

  return (
    <Flex className="kudo" vertical>
      <Text className="kudo__header" size="large" weight="bold">
        Kudos to...
      </Text>

      <Flex align="center" flex={1} gap="xs" justify="center" vertical>
        <Avatar size={64} src={user.profilePhoto?.url}>
          {fullName}
        </Avatar>

        <Title className="kudo__user-name" level={1}>
          {fullName}
        </Title>

        <MedalLineIcon className="kudo__bg-icon" />
      </Flex>
    </Flex>
  );
};

export default Kudo;
